import React from "react";
import service from 'axios';
import { withTranslation } from "react-i18next";
import { siteApi, YuklenenLogoUrl } from '../Utils';
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import MenuCategories from "../Component/MenuCategories";
import Questionnaire from "../Component/Questionnaire";
import ServiceModePopup from "../Component/ServiceModePopup";
import { useServiceMode } from "../helpers/UseServiceMode";

class TemplateMenu3 extends React.Component {
    constructor(props) {
        super(props);
        this.companyId = props.company.Id;
        this.branchId = new URLSearchParams(props.location.search).get('u');
        this.CompanyServiceModeState = props.company.QrMenuServiceModeState;

        this.cacheByLang = new Map();

        this.state = {
            Products: [],
            Company: {},
            Branch: {},
            ProductGroups: [],
            ProductsHtml: 0,
            serviceModePopup: false
        };

        this.previousLanguage = null;
    }

    componentDidMount() {
        const currentLang = this.props.i18n.language;
        this.previousLanguage = currentLang;
        this.loadLanguageData(currentLang);

        if (!this.CompanyServiceModeState) {
            try { localStorage.setItem("serviceMode", "pickup"); } catch { }
            window.dispatchEvent(new Event("serviceModeChanged"));
            return;
        } else {
            if (typeof window !== "undefined") {
                let existing = null;
                try {
                    existing = localStorage.getItem("serviceMode");
                } catch { }

                if (!existing) {
                    try { localStorage.setItem("serviceMode", "pickup"); } catch { }
                    window.dispatchEvent(new Event("serviceModeChanged"));
                }
                this.setState({ serviceModePopup: true });
            }
        }
    }

    componentDidUpdate() {
        const currentLang = this.props.i18n.language;
        if (this.previousLanguage !== currentLang) {
            this.loadLanguageData(currentLang);
            this.previousLanguage = currentLang;
        }
    }

    loadLanguageData(language) {
        const cached = this.cacheByLang.get(language);
        if (cached) {
            this.setState({ ...cached }, () => {
                document.title = this.state.Company?.Adi || document.title;
            });
            return;
        }
        this.getData(language);
    }

    getData(language) {
        return service
            .get(siteApi + "webmusteri/getQrMenuInfo", {
                params: {
                    companyId: this.companyId,
                    branchId: this.branchId,
                    language
                }
            })
            .then(res => {
                if (!res.data?.Success) return;

                const data = res.data.Data || {};
                const nextState = {
                    Products: data.Products || [],
                    ProductGroups: data.ProductGroups || [],
                    Branch: data.Branch ?? {},
                    Company: data.Company ?? {},
                };

                this.cacheByLang.set(language, nextState);

                this.setState(nextState, () => {
                    document.title = this.state.Company?.Adi || document.title;
                });
            })
            .catch(() => { });
    }

    formatTime(minutes) {
        if (typeof minutes !== "number") return "--:--";
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        const hh = String(hours).padStart(2, '0');
        const mm = String(mins).padStart(2, '0');
        return `${hh}:${mm}`;
    }

    isBranchOpen(startMinute, endMinute) {
        if (typeof startMinute !== "number" || typeof endMinute !== "number") return false;
        const now = new Date();
        const currentMinuteOfDay = now.getHours() * 60 + now.getMinutes();

        if (startMinute <= endMinute) {
            return currentMinuteOfDay >= startMinute && currentMinuteOfDay <= endMinute;
        } else {
            return false;
        }
    }

    getUpdatedDate() {
        try {
            const arr = this.state.Products ?? [];
            if (!Array.isArray(arr) || !arr.length) return new Date().toISOString();
            return arr.reduce((a, b) =>
                new Date(a.Updated) > new Date(b.Updated) ? a : b
            ).Updated;
        } catch {
            return new Date().toISOString();
        }
    }

    render() {
        const { Company, Branch } = this.state;
        const branchStart = Branch?.SubeBaslangicSaati;
        const branchEnd = Branch?.SubeBitisSaati;
        const packageStart = Branch?.PaketBaslangicSaati;
        const packageEnd = Branch?.PaketBitisSaati;

        const mode = this.props.mode || "pickup";

        return (
            <React.Fragment>
                <Header
                    logoSrc={Company.Logo}
                    bannerSrc={YuklenenLogoUrl + (Company.QrMenuBanner || "")}
                    place={(Branch?.WebGorunenAdi?.trim() || Branch?.Adi)}
                    hours={
                        mode === "pickup"
                            ? `${this.formatTime(branchStart)}-${this.formatTime(branchEnd)}`
                            : `${this.formatTime(packageStart)}-${this.formatTime(packageEnd)}`
                    }
                    companyColor={Company.KurumsalRenk || "#ff5533"}
                />
                <Questionnaire
                    companyInfo={Company}
                    updated={this.getUpdatedDate()}
                    visible={false}
                />
                <MenuCategories
                    categories={this.state.ProductGroups}
                    products={this.state.Products}
                    currencySymbol={
                        window.ayarlar?.currencyTourSymbol?.find(
                            x => x.code === (Company.DovizTuru || "TRY")
                        )?.symbol ?? "₺"
                    }
                    companyLogo={Company.Logo}
                    companyColor={Company.KurumsalRenk || "#ff5533"}
                    companyServiceModeState={this.CompanyServiceModeState}
                />
                <Footer
                    logoSrc={Company?.Logo}
                    adress={Branch?.Adres}
                    phone={Branch?.Telefon}
                    mail={Company?.Email}
                    socialLinks={{
                        Linkedin: Company?.LinkedinAdresi || "#",
                        Facebook: Company?.FacebookAdresi || "#",
                        Twitter: Company?.TwitterAdresi || "#",
                        Instagram: Company?.InstagramAdresi || "#",
                        Youtube: Company?.YoutubeAdresi || "#"
                    }}
                    companyColor={Company.KurumsalRenk || "#ff5533"}
                />
                <ServiceModePopup
                    isOpen={this.state.serviceModePopup}
                    onClose={() => this.setState({ serviceModePopup: false })}
                    accentColor={Company.KurumsalRenk}
                />
            </React.Fragment>
        );
    }
}

function TemplateMenu3WithMode(props) {
    const mode = useServiceMode();
    return <TemplateMenu3 {...props} mode={mode} />;
}

export default withTranslation()(TemplateMenu3WithMode);
